import { defineMessages } from "react-intl";

export const loyaltyTagMultiUpdateMessages = defineMessages({
  title: {
    id: "loyaltyTagMultiUpdate.title",
    defaultMessage: "Create preferences by Excel",
  },
  instructions: {
    id: "loyaltyTagMultiUpdate.instructions",
    defaultMessage: "Load the file you desire to import and click in the Import button",
  },
  instructionsDetail: {
    id: "loyaltyTagMultiUpdate.instructionsDetail",
    defaultMessage:
      '* If you want to add an icon, you will have to do it one by one in the edit preference option of the "Loyalty preferences list"',
  },
  dropFiles: {
    id: "loyaltyTagMultiUpdate.dropFiles",
    defaultMessage: "Drop files here...",
  },
  btnImportFile: {
    id: "loyaltyTagMultiUpdate.btnImportFile",
    defaultMessage: "Import",
  },
  btnDownloadFile: {
    id: "loyaltyTagMultiUpdate.btnDownloadFile",
    defaultMessage: "Download template",
  },
  back: {
    id: "loyaltyTagMultiUpdate.back",
    defaultMessage: "Back to preferences",
  },
});
